(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.evergreen = this.dataset.mode === 'evergreen';
        this.duration = Math.max(Number(this.dataset.duration) || 0, 60) * 1000;
        this.storageKey = `countdown-end:${this.dataset.key}`;
        this.end = this.evergreen ? this.#readEnd() : Number(this.dataset.end) * 1000;
        this.nums = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.nums[el.dataset.unit] = el;
        });
        this.tick = this.tick.bind(this);
        this.tick();
        this.timer = window.setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      /** Session-scoped end time: a new browser session starts from the full duration. */
      #readEnd() {
        let end = 0;
        try {
          end = Number(window.sessionStorage.getItem(this.storageKey)) || 0;
        } catch (_) {
          end = 0;
        }
        if (!(end > Date.now()) || end - Date.now() > this.duration) {
          end = this.#restart();
        }
        return end;
      }

      #restart() {
        const end = Date.now() + this.duration;
        try {
          window.sessionStorage.setItem(this.storageKey, String(end));
        } catch (_) {
          /* storage unavailable: the timer still runs for this page view */
        }
        return end;
      }

      tick() {
        let diff = this.end - Date.now();
        if (!(diff > 0)) {
          if (!this.evergreen) {
            window.clearInterval(this.timer);
            this.hidden = true;
            return;
          }
          this.end = this.#restart();
          diff = this.duration;
        }
        const total = Math.floor(diff / 1000);
        const values = {
          d: Math.floor(total / 86400),
          h: this.nums.d ? Math.floor((total % 86400) / 3600) : Math.floor(total / 3600),
          m: Math.floor((total % 3600) / 60),
          s: total % 60,
        };
        for (const unit in values) {
          const el = this.nums[unit];
          if (!el) continue;
          const text = String(values[unit]).padStart(2, '0');
          if (el.textContent !== text) el.textContent = text;
        }
      }
    }
    customElements.define('countdown-timer', CountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    /**
   * <kaching-price-sync>: mirrors the selected Kaching bundle price into the product price block.
   * - 1 unit: the bundle price and full price, as Kaching shows them.
   * - 2+ units: the per-unit price with "each" (and the per-unit full price struck through).
   * The sale badge is recalculated. Reads Kaching's rendered bars, so it follows every bundle
   * switch; if no selected bundle is found, the theme price stays visible.
   */
  if (!customElements.get('kaching-price-sync')) {
    const SELECTED_BAR = 'kaching-bundle .kaching-bundles__bar--selected';
    const BAR_UNIT = '.kaching-bundles__bar-variant';

    /** @param {string} text */
    const parseMoney = (text) => {
      const cleaned = String(text || '')
        .replace(/[^0-9.,]/g, '')
        .replace(/[.,](?=\d{3}(?:\D|$))/g, '')
        .replace(',', '.');
      const value = Number.parseFloat(cleaned);
      return Number.isFinite(value) ? value : NaN;
    };

    /** @param {Element | null} el @param {string} text */
    const setText = (el, text) => {
      if (el && el.textContent !== text) el.textContent = text;
    };

    /** @param {Element | null} el @param {boolean} hidden */
    const setHidden = (el, hidden) => {
      if (el && el.hidden !== hidden) el.hidden = hidden;
    };

    class KachingPriceSync extends HTMLElement {
      connectedCallback() {
        this.host = this.closest('product-price');
        this.scope = this.closest('.shopify-section') || document.body;
        this.priceEl = this.querySelector('[data-kps-price]');
        this.eachEl = this.querySelector('[data-kps-each]');
        this.compareEl = this.querySelector('[data-kps-compare]');
        this.compareWrap = this.querySelector('[data-kps-compare-wrap]');
        this.badgeEl = this.querySelector('[data-kps-badge]');
        this.schedule = this.schedule.bind(this);

        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.scope, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class'],
        });
        this.scope.addEventListener('change', this.schedule);
        this.schedule();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.scope?.removeEventListener('change', this.schedule);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      }

      /** @param {number} value */
      formatMoney(value) {
        if (!this.formatter) {
          try {
            this.formatter = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'en', {
              style: 'currency',
              currency: this.dataset.currency || window.Shopify?.currency?.active || 'USD',
            });
          } catch (_) {
            this.formatter = { format: (/** @type {number} */ amount) => amount.toFixed(2) };
          }
        }
        return this.formatter.format(value);
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.apply();
        });
      }

      apply() {
        const bar = this.scope.querySelector(SELECTED_BAR);
        const priceText = bar?.querySelector('.kaching-bundles__bar-price')?.textContent?.trim();

        if (!bar || !priceText) {
          this.setActive(false);
          return;
        }

        const fullText = bar.querySelector('.kaching-bundles__bar-full-price')?.textContent?.trim() || '';
        const price = parseMoney(priceText);
        const full = parseMoney(fullText);
        const units = Math.max(bar.querySelectorAll(BAR_UNIT).length, 1);
        const perUnit = units > 1 && Number.isFinite(price);
        const hasSaving = Number.isFinite(price) && Number.isFinite(full) && full > price;

        setText(this.priceEl, perUnit ? this.formatMoney(price / units) : priceText);
        setHidden(this.eachEl, !perUnit);

        const compareText = hasSaving ? (perUnit ? this.formatMoney(full / units) : fullText) : '';
        setText(this.compareEl, compareText);
        setHidden(this.compareWrap, !hasSaving);

        const showBadge = this.dataset.showBadge === 'true' && hasSaving;
        if (showBadge) {
          const percent = Math.round(((full - price) / full) * 100);
          setText(this.badgeEl, (this.dataset.badgeText || '[percent]% off').replace('[percent]', String(percent)));
        }
        setHidden(this.badgeEl, !showBadge);

        this.setActive(true);
      }

      /** @param {boolean} active */
      setActive(active) {
        if (this.host && this.host.classList.contains('kps-active') !== active) {
          this.host.classList.toggle('kps-active', active);
        }
      }
    }

    customElements.define('kaching-price-sync', KachingPriceSync);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    /**
   * Clicking a rating block with "Scroll to reviews" smoothly scrolls to the review widget
   * (Judge.me). Uses scrollIntoView so it works whichever element is the page's scroll
   * container, and scroll-margin to keep the widget clear of the sticky header.
   */
  if (!window.__ratingScrollToReviews) {
    window.__ratingScrollToReviews = true;

    const REVIEW_TARGETS = '.jdgm-review-widget, #judgeme_product_reviews, .jdgm-widget[data-widget="review"]';

    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-scroll-to-reviews]') : null;
      if (!link) return;

      const target = /** @type {HTMLElement | null} */ (document.querySelector(REVIEW_TARGETS));
      if (!target) return;

      event.preventDefault();

      const headerHeight = Number.parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      target.style.scrollMarginTop = `${Math.round(headerHeight) + 16}px`;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-chart')) {
    class SizeChart extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-size-chart-open]');
        this.trigger?.addEventListener('click', this.open);
        this.dialog?.addEventListener('click', this.onDialogClick);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.open);
        this.dialog?.removeEventListener('click', this.onDialogClick);
        if (this.dialog?.open) this.dialog.close();
      }

      open = () => {
        if (this.dialog && !this.dialog.open) this.dialog.showModal();
      };

      /** Close on the X button or a click on the backdrop (the dialog itself, outside the panel). */
      onDialogClick = (event) => {
        const target = event.target;
        if (target === this.dialog || (target instanceof Element && target.closest('[data-size-chart-close]'))) {
          this.dialog.close();
        }
      };
    }

    customElements.define('size-chart', SizeChart);
  }
  } catch(e) { console.error(e); }
})();

})();
